import type { AllActionTypes } from '../constants';
import constants from '../constants';
export interface State {
  device: {
    isMobile: boolean;
    screenWidth: string;
  };
  googleMapsApiKey: string;
}

export type Actions = { type: AllActionTypes; payload: State };

const initialState: State = {
  device: {
    isMobile: false,
    screenWidth: 'xl',
  },
  googleMapsApiKey: null,
};

const app = (state: State = initialState, action: Actions): State => {
  const { type, payload } = action;

  switch (type) {
    case constants.SET_APP_VALUES:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default app;
